import React from "react";
import { useTranslation } from "react-i18next";
import "./ConfirmDevice.css";
import SubHeader from "../../../../components/shared/subheader/SubHeader";
import ErrorPage from "../../../../components/shared/errorPage/ErrorPage";
import { refreshBtn, LOCALSESSIONDATAKEYS } from "../../../../constants/AppConstants";
import DisplayConfirmDevices from "../../../../components/DisplayDevices/DisplayConfirmDevice/DisplayConfirmDevices";
import { getLocalSessionData } from "../../../../utils/Authentication/handleUserSession";
import { useSelector } from "react-redux";

const ConfirmDevice = (props) => {
  const { t } = useTranslation(["translation"]);
  const deviceId = getLocalSessionData(LOCALSESSIONDATAKEYS.DEVICE_ID);;
  const deviceListResult = useSelector((state) => state.SelectDevice);
  const {unEnrolledDevicesList: devices} = deviceListResult || {};
  const devicesCount = devices?.length || 0;
  let confirmedDevice = {};

/**
 * Loop and match the confirmed device 
 */
  if (devicesCount > 0) {
    devices &&
      devices.map((device) => {
        if(device.deviceId === deviceId){
          confirmedDevice = device
        }
        return device;
      });
  }
  if (
    devicesCount > 0 &&
    devices.map((device) => device.hasOwnProperty("model"))
  ) {
    return (
      <div className="mt-40">
        <div className="confirm-device">
          <SubHeader
            currentStep="1"
            totalStep="4"
            stepName={t("SUB_HEADER.STEP_1.STEP_NAME")}
            stepInfo={t("SUB_HEADER.STEP_1.STEP_INFO")}
          />
          {confirmedDevice  &&
          <DisplayConfirmDevices confirmDevice={confirmedDevice}/>}
        </div>
      </div>
    );
  } else {
    return (
      <ErrorPage
        errorInfo={t("ERROR_CONTENT.NO_DEVICES")}
        showRefreshBtn={refreshBtn.HIDE}
      ></ErrorPage>
    );
  }
};

export default ConfirmDevice;
